const UserGroup = () =>
  import(
    /* webpackChunkName: "base-info-user-group" */ '@/pages/base-info/user/group/index.vue'
  )
const CreateUserGroup = () =>
  import(
    /* webpackChunkName: "base-info--user-group" */ '@/pages/base-info/user/group/create.vue'
  )
const EditUserGroup = () =>
  import(
    /* webpackChunkName: "base-info-user-group" */ '@/pages/base-info/user/group/edit.vue'
  )

export default {
  path: 'group',
  meta: {
    label: 'userGroup',
    auth: 'group'
  },
  component: {
    name: 'Group',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoUserGroupReport',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: UserGroup
    },
    {
      name: 'BaseInfoUserCreateGroup',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateUserGroup
    },
    {
      name: 'BaseInfoUserEditGroup',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditUserGroup,
      props: true
    }
  ]
}
